import React from "react";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { MlsIdBoard } from "model/agent-mls-ids";
import { PendingTag } from "../pending-tag";
import { styles } from "./style";

interface Props extends WithStyles<typeof styles> {
	board: MlsIdBoard | undefined;
	fallback?: string;
}

// A board's name in a table cell, with Pending Approval under it while the board waits on approval.
const Component: React.FC<Props> = ({ board, fallback = "", classes = {} }) => {
	return (
		<div className={classes.stack}>
			<span>{board?.name ?? fallback}</span>
			{board?.pending && <PendingTag />}
		</div>
	);
};

export const BoardCell = withStyles(Component, styles);
